import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { PurchaseReceiptsService } from './purchase-receipts.service';
import { CustomersService } from '../../customers/customers.service';
import { ProductsService } from '../../products/products.service';
import { StoresService } from '../../stores/stores.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl } from '@angular/forms';
import { SearchService } from '../../_services/search/search.service';
import { AuthenticationService } from '@app/_services';
import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ToastrService } from 'ngx-toastr';
import { DatePipe, DecimalPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MatTableDataSource, PageEvent, MatPaginator, MatDatepickerInputEvent } from '@angular/material';
enum PurchaseReceiptsElement {
  purchase_id,
  type,
  total,
  payment,
  supplier_id, supplier_name,
  store_id, store_name,
  purchase_date,
  user_id, user_name
}
enum ProductSoldOnElement {
  sell_id,
  product_id,
  store_id,
  purchase_date,
  purchase_id,
  quantity_bought,
  supplier_id,
  purchase_price
}


@Component({
  selector: 'app-purchase-receipts',
  templateUrl: './purchase-receipts.component.html',
  styleUrls: ['./purchase-receipts.component.css']
})
export class PurchaseReceiptsComponent implements OnInit {

  filter_dropdown = false;order_by = 'desc';
  loaded = false; from = null; to = null;
  ELEMENT_DATA: PurchaseReceiptsElement[];
  selection = new SelectionModel<PurchaseReceiptsElement>(true, []);
  showdd1 = false;
  showDeleteButton = false;
  report;
  date;
  length;
  pageSize = 10;
   pageIndex; pageEvent: PageEvent;
  
  page;
  columns;
  columns_selected = ['actions'];
  currentUserSubscription; currentUser; store_id;

  queryField: FormControl = new FormControl();

  constructor(private purchase_receiptsService: PurchaseReceiptsService,
    public dialog: MatDialog,
    private searchService: SearchService,
    private authenticationService: AuthenticationService,
    private toaster: ToastrService,
    private local: LocalStorageService,
    private route: ActivatedRoute, private cdr: ChangeDetectorRef) {
    window.scrollTo(0, 0);
    this.pageSize = JSON.parse(localStorage.getItem('pageSettings'))["purchase_receipts"]["items_per_page"];
    this.page = JSON.parse(localStorage.getItem('pageSettings'))["purchase_receipts"]["current_page"];
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user ? user[0] : "";
      if (this.currentUser.user_type != 'admin') {
        this.store_id = this.currentUser.store_id;
        this.local.set("store_id", this.store_id, 0, 's');
      }
      else {
        this.store_id = (this.local.get("store_id") == "all") ? this.currentUser.store_id : this.local.get("store_id");
      }

    });
  }

  ngOnInit() {
    this.date = this.route.snapshot.paramMap.get('date');
    this.pageSize = JSON.parse(localStorage.getItem('pageSettings'))["purchase_receipts"]["items_per_page"];
    this.page = JSON.parse(localStorage.getItem('pageSettings'))["purchase_receipts"]["current_page"];
    if (this.date != null) {
      this.date = new Date(this.date);
      this.purchase_receiptsService.getPurchaseReceiptsCountToday(this.date, this.store_id).toPromise().then((respons) => {
        this.length = respons[0]["COUNT(*)"];
      });
      var pageSettings = JSON.parse(localStorage.pageSettings);
      this.getSalesToday({
        'length': this.length,
        'pageIndex': pageSettings.purchase_receipts.current_page,
        'pageSize': pageSettings.purchase_receipts.items_per_page,
        'previousPageIndex': 0
      });
      this.getReport(this.date);
    }
    else {
      this.getNumberofPurchaseReceipts();
      this.getServerData(null);
      this.getReport(null);
    }
    this.queryField.valueChanges.subscribe(data => {
      this.searchService.searchPurchaseReceipt(data, this.store_id).toPromise().then((data: Array<PurchaseReceiptsElement>) => {

        this.ELEMENT_DATA = data;
      });
    });
    this.purchase_receiptsService.getPurchaseReceiptsColumns().toPromise().then(data => {
      let i = 0; 
      this.columns = data;
      for (const key in data) {
        i++;
        if (data[key]['show'] == 1) {
          this.columns_selected.push((data[key]['column_name'] == "supplier_id") ? "supplier_name" :
          (((data[key]['column_name'] == "store_id") ? "store_name" :
            (((data[key]['column_name'] == "user_id") ? "user_name" : data[key]['column_name'])))));
          
        }
      }
      this.loaded = true;
    });

  }

  getColumnName(inp): string {
    if (inp == "purchase_id") return "Receipt Id";
    if (inp == "total") return "Total"; ///////////
    if (inp == "payment") return "Bill	Paid";
    if (inp == "supplier_id" || inp == "supplier_name") return "Customer";
    if (inp == "store_id" || inp == "store_name") return "Store";
    if (inp == "purchase_date") return "Purchase Date";
    if (inp == "user_id" || inp == "user_name") return "User";
    if (inp == "comments") return "Comments";
  }
  getNumberofPurchaseReceipts = function () {
    this.purchase_receiptsService.getPurchaseReceiptsCount(this.store_id).toPromise().then(respons => {
      this.length = respons[0]["COUNT(*)"];
    });
  }
  public getServerData(event?: PageEvent) {
    if (this.store_id !== 'all') {
      if (event) {
        this.purchase_receiptsService.getPurchaseReceipts(event, this.store_id, this.to , this.from , this.order_by, this.queryField.value).subscribe((data: Array<PurchaseReceiptsElement>) => {

            this.ELEMENT_DATA = data;
            var pageSettings = JSON.parse(localStorage.pageSettings);
            
            pageSettings.purchase_receipts = {"items_per_page": this.pageEvent["pageSize"], "current_page": this.pageEvent["pageIndex"]};
            localStorage.setItem("pageSettings", JSON.stringify(pageSettings)); 
          });
      }
      else {
        var pageSettings = JSON.parse(localStorage.pageSettings);
        this.purchase_receiptsService.getPurchaseReceipts({
          'length': this.length,
          'pageIndex': pageSettings.purchase_receipts.current_page,
          'pageSize': pageSettings.purchase_receipts.items_per_page,
          'previousPageIndex': 0
        }, this.store_id, this.to , this.from , this.order_by, this.queryField.value).subscribe((data: Array<PurchaseReceiptsElement>) => {
            this.ELEMENT_DATA = data;
          });
      }
    }
    else {
      this.getPurchaseReceipts()
    }
    return event;
  }
  getReport(date) {
    this.purchase_receiptsService.getReport(date, this.store_id).subscribe(data => {
      this.report = data[0];
    })
  }
  selectionChange(item, i, event) {
    this.purchase_receiptsService.setPurchaseReceiptsColumnDisplay(item['column_name'], event).subscribe(data => { }
    );
    for (let ind = 0; ind < this.columns.length; ind++) {
      if (this.columns[ind].column_name == item.column_name) {
        this.columns[ind].show = event;
        break;
      }
    }
    this.columns_selected = ["actions"];
    for (let ind = 0; ind < this.columns.length; ind++) {
      if (this.columns[ind].show) {
        this.columns_selected.push((this.columns[ind].column_name == "supplier_id") ? "supplier_name" :
        (((this.columns[ind].column_name == "store_id") ? "store_name" :
          (((this.columns[ind].column_name == "user_id") ? "first_name" : this.columns[ind].column_name)))));
        
      }
    }
    this.cdr.detectChanges();
  }
  
  PageChanged() {
    var pageSettings = JSON.parse(localStorage.pageSettings);
    pageSettings.purchase_receipts = { "items_per_page": this.pageSize, "current_page": this.page };
    localStorage.setItem("pageSettings", JSON.stringify(pageSettings));
  }
  pageSizeChange() {
    var pageSettings = JSON.parse(localStorage.pageSettings);
    pageSettings.purchase_receipts = { "items_per_page": this.pageSize, "current_page": this.page };
    localStorage.setItem("pageSettings", JSON.stringify(pageSettings));
  }
  getPurchaseReceipts() {
    this.purchase_receiptsService.getAllPurchaseReceipts().subscribe((data: Array<PurchaseReceiptsElement>) => {
      this.ELEMENT_DATA = data;
      var pageSettings = JSON.parse(localStorage.pageSettings);
      
      pageSettings.purchase_receipts = {"items_per_page": this.pageEvent["pageSize"], "current_page": this.pageEvent["pageIndex"]};
      localStorage.setItem("pageSettings", JSON.stringify(pageSettings)); 
    });
  }
  toggleDD(id) {
    if (document.getElementById(id).style.display == 'block') {
      document.getElementById(id).style.display = 'none';
    }
    else {
      document.getElementById(id).style.display = 'block';
    }
  }
  search(event?: PageEvent) {
    if (!event) {
      this.purchase_receiptsService.getPurchaseReceipts({
        'length': this.length,
        'pageIndex': 0,
        'pageSize': this.pageSize,
        'previousPageIndex': 0
      }, this.store_id, this.to, this.from, this.order_by, this.queryField.value).subscribe((data: Array<PurchaseReceiptsElement>) => {
        this.ELEMENT_DATA = data;
      });
    }
    else {
      this.purchase_receiptsService.getPurchaseReceipts(event, this.store_id, this.to, this.from, this.order_by, this.queryField.value).subscribe((data: Array<PurchaseReceiptsElement>) => {
        this.ELEMENT_DATA = data;
      });
    }
  }
  openPurchaseReceiptDialog = function (receipt): void {
    const dialogRef = this.dialog.open(PurchaseReceiptDialog, {
      height: '100%',
      width: '80%',
      data: { "id": receipt.purchase_id, "receipt": receipt }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  getSalesToday(event) {
    this.purchase_receiptsService.getPurchaseReceiptsToday(this.date, this.store_id, event).toPromise().then((data: Array<PurchaseReceiptsElement>) => {
      this.ELEMENT_DATA = data;
    });
  }
}

@Component({
  selector: 'purchase-receipts-dialog',
  templateUrl: 'purchase-receipts-dialog.html',
  styleUrls: ['../../receipt/receipt.component.css'],
  providers: [DatePipe, DecimalPipe]
})

export class PurchaseReceiptDialog implements AfterViewInit {
  predefined = false; model; id; supplier; store; receipt; scale = 0.5; company; net_total = 0; 
  vat_amount = 0; total = 0; payment = 0; sold_by; additional_charges;
  email_id; send_email; supplier_ref; extra_note; comments; shipment; vat = 20;
  constructor(
    public dialogRef: MatDialogRef<PurchaseReceiptDialog>, private purchase_receiptsService: PurchaseReceiptsService, private toasterService: ToastrService,
    private customersService: CustomersService, private productsService: ProductsService, private storesService: StoresService,
    private datePipe: DatePipe, private dp: DecimalPipe,
    @Inject(MAT_DIALOG_DATA) public data) {
    window.scrollTo(0, 0);

    this.id = data.id;
    this.receipt = data.receipt;
    this.purchase_receiptsService.getPurchaseReceipt(this.id).toPromise().then((data) => {
      this.receipt = data["receipt"];
      this.additional_charges = data["additional_charges"];
      this.model = data["receipt_details"];
      this.supplier = data["receipt"]["supplier"];
      this.vat = this.supplier["vat_percentage"];
      this.store = data["receipt"]["store"];
      this.company = data["receipt"]["company"];
      this.sold_by = data["receipt"]["user"].first_name.charAt(0) + data["receipt"]["user"].last_name.charAt(0);
      this.extra_note = this.receipt["extra_note"];
      this.supplier_ref = this.receipt["supplier_ref"];
      this.comments = this.receipt["comments"];
      this.net_total = this.receipt["net"];
      this.vat_amount = this.receipt["vat"];
      this.total = this.receipt["total"];
      this.model.forEach(element => {
        element.display_price = <number>(element.purchase_price);
        var str = (element.purchase_price).toFixed(2); // => '10.23'
        var number = Number(str);
      });
    });

  }
  ngAfterViewInit() {
  }
  email() {
    this.send_email = true;
    this.supplier.email = this.email_id;
  }

  send() {
    if (this.email_id) {
      this.supplier["email_id"] = this.email_id;
    }
    var datetime = new Date(this.receipt["purchase_date"]);
    var dt = datetime.getTime() / 1000;
    var tempInvoice = <string>(this.store.store_name.split(" ")[0].charAt(0)) + <string>(this.store.store_name.split(" ")[1] ? this.store.store_name.split(" ")[1].charAt(0) :
      this.store.store_name.split(" ")[0].charAt(1)) + <string>(this.dp.transform(this.id, '3.0-0'));
    var data = {
      "invoice_number": tempInvoice, "purchase_date": dt, "model": this.model, "store": this.store, "company": this.company, "sold_by": this.sold_by, "total": this.total,
      "vat_amount": this.vat_amount, "receipt": this.receipt, "net_total": this.net_total, "customer": this.supplier, "customer_ref": this.supplier_ref,
      "extra_note": this.extra_note, "comments": this.comments
    };
    this.purchase_receiptsService.resend(data).subscribe(data => {
      if (data == "sent") {
        this.toasterService.success('Sending Email was Successful!', 'Email Sent', {
          //       timeOut: 5000
          //     });
        });
      }
    })
  }

  onNoClick(): void {
    this.dialogRef.close(this.model);
  }
  public generatePDF() {

    document.getElementById("myDivs").style.pageBreakInside = "never";
    // alert(document.getElementById("myTable")['rows'].length);

    var a = document.getElementById("myTable")['rows'].length;

    if (a < 16) //first page bottom bar
    {
      document.getElementById("myDivs").style.position = 'absolute';
      document.getElementById("myDivs").style.bottom = '0';
      document.getElementById("myDivs").style.width = '87%';
      document.getElementById("myDivs").style.height = '15rem';
      // document.getElementById("myDivs").style.marginTop = '62%'
    }
    else if (a >= 16 && a <= 17) //second page bar
    {

      document.getElementById("myDiv").style.pageBreakAfter = "always";

      document.getElementById("myDivs").style.marginTop = '127%';
    }
    else if (a > 17 && a <= 43) //second page bar
    {
      // document.getElementById("myDivs").style.height = null;
      // document.getElementById("myDivs").style.pageBreakInside = "never";
      // // document.getElementById("myDiv").style.pageBreakAfter = "always";
      //   var b = a - 19;
      //   var c = b * 106.3;
      //   var d = 3508 - c - 3508/40 ;
      //   var e  = Math.floor(d) + "px";
      //   // document.getElementById("myDivs").style.height = null;
      //   document.getElementById("myDivs").style.marginTop = e;
      var b = a - 17;
      var c = b * 4.72;
      var d = 115 - c;
      var e = d + "%";

      document.getElementById("myDivs").style.marginTop = e;
    }

    else if (a > 43 && a < 49) //second page bar
    {
      var b = a - 43;
      var c = b * 4.72;
      var d = 115 - c;
      var e = d + "%";

      document.getElementById("myDivs").style.marginTop = e;
    }

    else if (a >= 51 && a <= 55) //third page bar
    {
      document.getElementById("myDiv").style.pageBreakAfter = "always";

      document.getElementById("myDivs").style.marginTop = '127%'
    }

    else if (a > 55 && a < 84) //third page bar
    {
      var b = a - 55;
      var c = b * 4.72;
      var d = 115 - c;
      var e = d + "%";

      document.getElementById("myDivs").style.marginTop = e;
    }

    else if (a >= 84 && a <= 88) //fourth page bar
    {
      document.getElementById("myDiv").style.pageBreakAfter = "always";

      //document.getElementById("myDivs").style.marginTop = '127%'

      document.getElementById("myDivs").style.marginBottom = '10px';
    }

    else if (a > 88 && a < 117) //fourth page bar
    {
      var b = a - 88;
      var c = b * 4.72;
      var d = 115 - c;
      var e = d + "%";

      //document.getElementById("myDivs").style.marginTop = e;
      document.getElementById("myDivs").style.marginBottom = '10px';

    }

    else if (a >= 117 && a <= 121) //fifth page bar
    {
      document.getElementById("myDiv").style.pageBreakAfter = "always";

      document.getElementById("myDivs").style.marginTop = '127%'
    }

    else if (a > 121 && a < 150) //fifth page bar
    {
      var b = a - 121;
      var c = b * 4.72;
      var d = 115 - c;
      var e = d + "%";

      document.getElementById("myDivs").style.marginTop = e;
    }

    else if (a >= 150 && a <= 154) //sixth page bar
    {
      document.getElementById("myDiv").style.pageBreakAfter = "always";

      document.getElementById("myDivs").style.marginTop = '127%'
    }

    else if (a > 154 && a < 183) //sixth page bar
    {
      var b = a - 154;
      var c = b * 4.72;
      var d = 115 - c;
      var e = d + "%";

      document.getElementById("myDivs").style.marginTop = e;
    }

    else if (a >= 183 && a <= 187) //seventh page bar
    {
      document.getElementById("myDiv").style.pageBreakAfter = "always";

      document.getElementById("myDivs").style.marginTop = '127%'
    }

    else if (a > 187 && a < 216) //seventh page bar
    {
      var b = a - 187;
      var c = b * 4.72;
      var d = 115 - c;
      var e = d + "%";

      document.getElementById("myDivs").style.marginTop = e;
    }

    else if (a >= 216 && a <= 220) //eighth page bar
    {
      document.getElementById("myDiv").style.pageBreakAfter = "always";

      document.getElementById("myDivs").style.marginTop = '127%'
    }

    else if (a > 220 && a < 249) //eighth page bar
    {
      var b = a - 220;
      var c = b * 4.72;
      var d = 115 - c;
      var e = d + "%";

      document.getElementById("myDivs").style.marginTop = e;
    }

    var data = document.getElementById("template_invoice").innerHTML;
    var html = "<html>";
    html += "<head>";
    html += "<style>@media print{@page{size:auto;size: A4 portrait;margin-top: 0%;margin-bottom: 0%;margin-left: 0%;margin-right: 0%;border: 1px solid red;orphans:5; widows:4;}@page :nth(2) body{orphans:5; widows:4;margin-top:5%}</style>"
    html += "<style>@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,400italic,600,700&subset=cyrillic,cyrillic-ext,latin,greek-ext,greek,latin-ext,vietnamese);a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h2,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font:inherit;font-size:100%;vertical-align:baseline}html{line-height:1}ol,ul{list-style:none}{border-collapse:collapse;border-spacing:0}caption,td,th{text-align:left;font-weight:400;vertical-align:middle}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:'';content:none}a img{border:none}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}.clearfix{display:block;clear:both}.hidden{display:none}.bold,b,strong{font-weight:700}#template_invoice{height:auto;overflow:auto;width:21cm;padding:.5cm;margin:.2cm auto;border:1px #d3d3d3 solid;border-radius:5px;background:#fff;box-shadow:0 0 5px rgba(0,0,0,.1)}#container{height:fit-content;font:normal 13px/1.4em 'Open Sans',Sans-serif;margin:5px 5px;padding:5px 5px;min-height:26cm;max-height:fit-content}#memo .company-name{background:#fff 560px center no-repeat;background-size:100px auto;display:inline-block;margin-bottom:25px;padding:5px 0 5px 0}#memo .company-name span{color:#1dafec;display:inline-block;min-width:20px;font-size:75px;font-weight:700;line-height:1em}#memo .company-name .right-arrow{position:absolute;top:0;right:0;bottom:0;width:100px;background:right center no-repeat;background-size:auto 60px}#memo .logo{float:left;clear:left;margin-left:20px}#memo .logo img{width:150px;height:100px}#memo .company-info{float:right;text-align:right;display:inline-block;margin-left:20px;font-size:12px;color:#8b8b8b}#memo .company-info div{margin-bottom:5px;min-width:20px}#memo .company-info span{display:inline-block;min-width:20px}#memo:after{border-bottom:2px solid #000;content:'';display:block;clear:both}#invoice-info{float:right;margin:5px 0 0 20px}#invoice-info>div{float:right}#invoice-info>div>span{display:block;min-width:20px;min-height:18px;margin-bottom:3px}#invoice-info>div:last-child{margin-right:20px}#invoice-info:after{content:'';display:block;clear:both}#client-info{float:left;margin:5px 20px 0 0;min-width:220px;text-align:left}#client-info>div{margin-bottom:6px;min-width:20px}#client-info span{display:block;min-width:20px}#bill_to_label{font-weight:600;font-size:18px;margin-bottom:5px}#invoice-title-number{text-align:center;margin:20px 0}#invoice-title-number span{display:inline-block;min-width:20px}#invoice-title-number #title{margin-right:15px;text-align:right;font-size:20px;font-weight:700}#invoice-title-number #number{font-size:15px;text-align:left}#invoice-info  th{margin-right:3px;font-weight:650}#invoice-info  td{margin-left:3px;float:right}{-layout:fixed} td, th{vertical-align:top;word-break:keep-all;word-wrap:break-word;margin-bottom:10px}#items{margin:20px 0 35px 0}#items {border-collapse:separate;width:100%}#items  th{padding:12px 10px;text-align:left;background:#e6e7e7;border-bottom:4px solid rgba(200,211,211,.452)}#items  th:last-child{text-align:right;padding-right:20px!important}#items  tr{page-break-before:auto;page-break-inside:avoid!important;page-break-after:auto}#items  td{padding:5px 7px;text-align:left;border-right:1px solid #cccccf;border-bottom:1px solid rgba(200,211,211,.452);page-break-before:auto;page-break-inside:avoid!important;page-break-after:auto}#items  td:first-child{text-align:left;border-right:0!important}#items  td:last-child{text-align:right;border-right:0!important}#items  td:nth-child(2){text-align:left}#items  td:nth-child(5){text-align:right}#items  th:nth-child(1){width:20%!important}#items  th:nth-child(2){width:32%!important;text-align:left}#items  th:nth-child(3){width:13%!important}#items  th:nth-child(4){width:13%!important}#items  th:nth-child(5){width:7%!important}#items  th:nth-child(6){width:15%!important}#items  td:last-child{border-right:0!important;padding-right:20px!important}.currency{padding:0 10px 0 0}.currency span{font-size:11px;font-style:italic;color:#8b8b8b;display:inline-block;min-width:15px}#hr{bottom:200;border-bottom:2px solid #000;content:'';display:block;clear:both}#sums{position:relative;left:0;top:0;float:right;background:#f0f0f0;background-size:auto 100px;color:#000;font-size:16px;margin-top:inherit;page-break-before:auto;page-break-inside:avoid;page-break-after:avoid}#sums  tr td,#sums  tr th{padding:3px 10px 3px 10px;text-align:right}#sums  tr td dd{display:inline-block}#sums  tr th{text-align:left;padding-right:10px}#sums  tr td{width:200px auto!important;padding-right:10px}.payment-info{margin:0 20px}.payment-info div{font-size:18px;color:#8b8b8b;display:inline-block;min-width:20px}.ib_bottom_row_commands{margin:10px 0 0 20px!important}@media print{@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,400italic,600,700&subset=cyrillic,cyrillic-ext,latin,greek-ext,greek,latin-ext,vietnamese);a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h2,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font:inherit;font-size:100%;vertical-align:baseline}html{line-height:1}ol,ul{list-style:none}#white{padding:3%;background-color:#fff}{border-collapse:collapse;border-spacing:0}caption,td,th{text-align:left;font-weight:400;vertical-align:middle}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:'';content:none}a img{border:none}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}.clearfix{display:block;clear:both}.hidden{display:none}.bold,b,strong{font-weight:700}#template_invoice{height:auto;overflow:auto;width:21cm;padding:.5cm;margin:.2cm auto;border:1px #d3d3d3 solid;border-radius:5px;background:#fff;box-shadow:0 0 5px rgba(0,0,0,.1);page-break-before:auto;page-break-inside:auto;page-break-after:auto}#container{font:normal 13px/1.4em 'Open Sans',Sans-serif;margin:5px 5px;padding:5px 5px;min-height:26cm;max-height:fit-content;height:fit-content;page-break-before:auto;page-break-inside:auto;page-break-after:auto}#memo .company-name{background:#fff 560px center no-repeat;background-size:100px auto;display:inline-block;margin-bottom:25px;padding:5px 0 5px 0}#memo .company-name span{color:#1dafec;display:inline-block;min-width:20px;font-size:75px;font-weight:700;line-height:1em}#memo .company-name .right-arrow{position:absolute;top:0;right:0;bottom:0;width:100px;background:right center no-repeat;background-size:auto 60px}#memo .logo{float:left;clear:left;margin-left:20px}#memo .logo img{width:150px;height:100px}#memo .company-info{float:right;text-align:right;display:inline-block;margin-left:20px;font-size:12px;color:#8b8b8b}#memo .company-info div{margin-bottom:5px;min-width:20px}#memo .company-info span{display:inline-block;min-width:20px}#memo:after{border-bottom:2px solid #000;content:'';display:block;clear:both}#invoice-info{float:right;margin:5px 0 0 20px}#invoice-info>div{float:right}#invoice-info>div>span{display:block;min-width:20px;min-height:18px;margin-bottom:3px}#invoice-info>div:last-child{margin-right:20px}#invoice-info:after{content:'';display:block;clear:both}#client-info{float:left;margin:5px 20px 0 0;min-width:220px;text-align:left}#client-info>div{margin-bottom:6px;min-width:20px}#client-info span{display:block;min-width:20px}#bill_to_label{font-weight:600;font-size:18px;margin-bottom:5px}#invoice-title-number{text-align:center;margin:20px 0}#invoice-title-number span{display:inline-block;min-width:20px}#invoice-title-number #title{margin-right:15px;text-align:right;font-size:20px;font-weight:700}#invoice-title-number #number{font-size:15px;text-align:left}#invoice-info  th{margin-right:3px;font-weight:650}#invoice-info  td{margin-left:3px;float:right}{-layout:fixed} td, th{vertical-align:top;word-break:keep-all;word-wrap:break-word;margin-bottom:10px}#items{margin:20px 0 35px 0}#items {border-collapse:separate;width:100%;page-break-before:auto;page-break-inside:auto;page-break-after:auto}#items  th{padding:12px 10px;text-align:left;background:#e6e7e7;border-bottom:4px solid rgba(200,211,211,.452)}#items  th:last-child{text-align:right;padding-right:20px!important}#items  tr{page-break-before:auto;page-break-inside:avoid!important;page-break-after:auto}#items  td{padding:5px 7px;text-align:left;border-right:1px solid #cccccf;border-bottom:1px solid rgba(200,211,211,.452);page-break-before:auto;page-break-inside:avoid!important;page-break-after:auto}#items  td:first-child{text-align:left;border-right:0!important}#items  td:last-child{text-align:right;border-right:0!important}#items  td:nth-child(2){text-align:left}#items  td:nth-child(5){text-align:right}#items  th:nth-child(1){width:20%!important}#items  th:nth-child(2){width:32%!important;text-align:left}#items  th:nth-child(3){width:13%!important}#items  th:nth-child(4){width:15%!important}#items  th:nth-child(5){width:7%!important}#items  th:nth-child(6){width:15%!important}#items  td:last-child{border-right:0!important;padding-right:20px!important}.currency{padding:0 10px 0 0}.currency span{font-size:11px;font-style:italic;color:#8b8b8b;display:inline-block;min-width:15px}#hr{bottom:200;border-bottom:2px solid #000;content:'';display:block;clear:both}#sums{position:relative;left:0;top:0;margin-top:inherit;float:right;background:#f0f0f0;background-size:auto 100px;color:#000;font-size:16px;page-break-before:auto;page-break-inside:avoid;page-break-after:avoid}#sums  tr td,#sums  tr th{padding:3px 10px 3px 10px;text-align:right;page-break-before:auto;page-break-inside:avoid;page-break-after:auto}#sums  tr td dd{display:inline-block}#sums  tr th{text-align:left;padding-right:10px}#sums  tr td{width:200px auto!important;padding-right:10px}.payment-info{margin:0 20px}.payment-info div{font-size:18px;color:#8b8b8b;display:inline-block;min-width:20px}.ib_bottom_row_commands{margin:10px 0 0 20px!important}.header{font-size:35px;text-align:center;font-weight:700;margin:0 0 20px 0;color:#3aabf0}.address{font-size:26px;display:flex;justify-content:space-between;margin:0 0 20px 0}.for p,.from p{font-size:26px;color:#787878}.from div,.from h3,.from span{font-size:26px;text-align:left}.for div,.for h3,.for span{text-align:left}.total_headings div{margin-left:80%}.signature{padding-top:36px}.currency_symbol{margin-left:0;text-align:left}.currency::before{content:'£  '}}.header{font-size:35px;text-align:center;font-weight:700;margin:0 0 20px 0;color:#3aabf0}.address{font-size:26px;display:flex;justify-content:space-between;margin:0 0 20px 0}.for p,.from p{font-size:26px;color:#787878}.from div,.from h3,.from span{font-size:26px;text-align:left}.for div,.for h3,.for span{text-align:left}.total_headings div{margin-left:80%}.signature{padding-top:36px}.currency_symbol{margin-left:0;text-align:left}.currency::before{content:'£  '}</style>";
    html += "</head>";
    html += "<div id='white'>"
    html += document.getElementById("template_invoice").innerHTML;
    html += "</div>";
    html += "</html>";
    var printWin = window.open('', '', 'left=0,top=0,toolbar=0,scrollbars=0,status  =0');
    printWin.document.write(html);
    printWin.document.close();
    printWin.focus();
    printWin.document.title = "";
    printWin.print();
  }

}


